import { initialModule, ModuleMetadata } from '../base/initial-module';

import { SpecPipeOptions } from './options';

/**
 * @internal
 */
export function initialSpecPipeModule<D, H>(options: Required<SpecPipeOptions<D, H>>): ModuleMetadata {
  const moduleMetadata = initialModule(options);

  moduleMetadata.declarations.push(options.pipe);
  moduleMetadata.declarations.push(options.host);

  return moduleMetadata;
}
